<template>
    <router-view></router-view>
</template>
<script type="text/babel">
export default {
  components: {},
  data() {
    return {}
  },
  methods: {},
  created() {},
}
</script>
